
import { RevModal } from '@ds/components/Modal'
import { IconCalendarWithCheck } from '@ds/icons/IconCalendarWithCheck'
import { IconClock } from '@ds/icons/IconClock'
import { IconTruck } from '@ds/icons/IconTruck'

import { MODAL_NAMES } from '@config/constants'

import ContentRow from '../../ContentRow'

import translations from './ShippingModal.translations'

export default {
  components: {
    RevModal,
    ContentRow,
  },
  computed: {
    translations: () => translations,
    modalName: () => MODAL_NAMES.PRODUCT.EXPRESS_SHIPPING,

    icons() {
      return {
        IconClock,
        IconCalendarWithCheck,
        IconTruck,
      }
    },
  },
}
